export default "__VITE_ASSET__B_FwA6Qw__"